import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import {orange500} from 'material-ui/styles/colors';

import LoadingIndicator from './shared/LoadingIndicator';

import CompanyList from './shared/CompanyList';
import CompanyService from '../service/companies';
import AdminHeader from './AdminHeader';

export default class NameSearchPage extends Component {

  state = {
    searchText: "",
    foundCompanies: [],
    hintText: undefined,
    searchTimer: null,
    searching: false,
    selectedCompanies: []
  };

  timeout = undefined;

  componentDidMount() {
    var params = this.props.location.query;
    if (params.searchText && params.searchText.length > 0) {
      this.onSearchTextChanged(params.searchText);
    }
  }

  onSearchTextEntered(event) {
    this.onSearchTextChanged(event.target.value);
  }

  onSearchTextChanged(text) {
    this.setState({searchText: text});

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    if (text.length > 2) {
      this.setState({hintText: undefined});
      this.timeout = setTimeout(this.search.bind(this), 1000);
    } else {
      this.timeout = setTimeout(this.displayHint.bind(this), 1000);
    }
  }

  onSelectedCompanies(selectedCompanies) {
    setTimeout(function() {
      this.setState({'selectedCompanies': selectedCompanies});
    }.bind(this), 0);
  }

  displayHint() {
    this.setState({hintText: "Syötä vähintään 3 merkkiä"});
  }

  search() {
    this.setState({searching: true});
    this.performSearch();
  }

  performSearch() {
    CompanyService.findCompanies({from: 0, to: 10, name: this.state.searchText}).then(companies => {
      setTimeout(function() {
        this.setState({searching: false});
        this.setState({foundCompanies: companies.companies, selectedCompanies: []});
      }.bind(this), 0);
    }).catch(error => this.setState({searching: false}));
  }

  render() {
    var content = <LoadingIndicator />;

    if (!this.state.searching) {
      content = <CompanyList multiSelectable={true}
        companies={this.state.foundCompanies}
        onSelectedCompanies={(selectedCompanies) => this.onSelectedCompanies(selectedCompanies)}
        selectedCompanies={this.state.selectedCompanies}
        refreshList={() => this.performSearch()}
        total={this.state.foundCompanies.length} />;
    }

    return (
      <div>
        <AdminHeader selected="namesearch" />
        <div className="main-container">
          <TextField
            floatingLabelText="Hae nimellä"
            value={this.state.searchText}
            errorText={this.state.hintText}
            errorStyle={{color: orange500}}
            onChange={(event) => this.onSearchTextEntered(event)}
            style={{marginLeft:"165px"}}
            />
        </div>
        {content}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NameSearchPage.js